export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/EnvelopeBlack.adeeda67.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};